import {ReactComponent as STEP1} from "../../icons/gis/floatingPopulationModal/step1.svg";
import {ReactComponent as STEP2} from "../../icons/gis/floatingPopulationModal/step2.svg";
import {ReactComponent as STEP3} from "../../icons/gis/floatingPopulationModal/step3.svg";
import {ReactComponent as STEP4} from "../../icons/gis/floatingPopulationModal/step4.svg";
import {ReactComponent as STEP5} from "../../icons/gis/floatingPopulationModal/step5.svg";

export const CrowdedStepGuideList = [
  {
    step: 1,
    status: "여유",
    range1: "100㎡에 약 1명",
    range2: "0 ~ 30명",
    content: "사람들이 몰려있을 가능성이 없으며 붐빔이 느껴지지 않습니다. 도보 이동 시 제약이 없으며 이동이 자유로워 사고가 발생할 가능성이 없습니다. 특정 장소나 구간에 인구 집중 현상도 없으며, 방문 시 쾌적한 환경으로 이용할 수 있는 단계입니다.",
    icon: <STEP1 />,
  },
  {
    step: 2,
    status: "보통",
    range1: "100㎡에 약 3명",
    range2: "31 ~ 60명",
    content: "사람들이 몰려있을 가능성이 낮고 붐빔이 느껴지지 않습니다. 도보 이동 시 큰 제약이 없으며 이동이 자유로워 사고가 발생할 가능성이 낮습니다. 그러나, 특정 지역에 다소 인구가 집중되어 있을 수 있을 가능성이 있으므로 보통단계입니다.",
    icon: <STEP2 />,
  },
  {
    step: 3,
    status: "주의",
    range1: "100㎡에 약 6명",
    range2: "61 ~ 100명",
    content: "사람들이 몰려있을 가능성은 있지만, 크게 붐비지는 않습니다. 도보 이동 시 큰 제약이 없으며, 부딪힘, 낙상 등의 사고가 발생할 가능성은 상대적으로 낮으나, 특정 지역이나 구간에 인파 밀집으로 인한 사고가 발생한 가능성은  존재하므로 주의가 필요한 단계입니다.",
    icon: <STEP3 />,
  },{
    step: 4,
    status: "경계",
    range1: "100㎡에 약 10명",
    range2: "101 ~ 200명",
    content: "사람들이 몰려있을 가능성이 높으며, 인구 밀도가 다소 높은 특정 구간에서는 도보 이동 시 부딪힘, 낙상 등의 안전사고가 발생할 가능성이 존재합니다. 인파 밀집으로 인한 사고가 발생하지 않도록 사전에 알림 및 예방조치가 필요한 단계입니다.",
    icon: <STEP4 />,
  },
  {
    step: 5,
    status: "심각",
    range1: "100㎡에 약 15명",
    range2: "201명 이상~",
    content: "사람들이 몰려있을 가능성이 매우 높으며, 인구 밀도가 높은 특정 구간에서는 도보 이동 시 부딪힘, 낙상 등의 안전사고가 발생할 매우 가능성이 높습니다. 인파 밀집으로 인한 사고가 발생하지 않도록 신속한 현장 조치가 필요한 단계입니다. ",
    icon: <STEP5 />,
  },
]
